import { FieldMappingRow } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/FieldMappingRow";
import { Flex } from "@theorgchartdev/storybook";
import SectionCard from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import { appstr } from "@coreapp/utils/appstr";
import { GetFilteredOptionalFields } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/Utils";

export const OptionalFieldMappingSection = ({
  localConfig,
  BuildFieldMappingOptions,
  disableDropdowns,
  handleFieldRename,
  handleCustomFieldNameValidation
}) => {
  const filteredOptionalFieldKeys = GetFilteredOptionalFields(localConfig);

  if (!filteredOptionalFieldKeys || filteredOptionalFieldKeys.length === 0) {
    return null;
  }

  return (
    <SectionCard title={appstr("Employee details field mapping")}>
      <Flex direction={"column"} gap={"16px"}>
        {filteredOptionalFieldKeys.map(key => (
          <FieldMappingRow
            key={key}
            fieldKey={key}
            fieldValue={localConfig.fields ? localConfig.fields[key] : null}
            localConfig={localConfig}
            BuildFieldMappingOptions={BuildFieldMappingOptions}
            disabled={disableDropdowns}
            handleFieldRename={handleFieldRename}
            handleCustomFieldNameValidation={handleCustomFieldNameValidation}
            required={false}
          />
        ))}
      </Flex>
    </SectionCard>
  );
};
